import React, { useState } from 'react'

import { EuiButton, EuiConfirmModal, EuiFieldText, EuiFlexGroup, EuiFlexItem, EuiFormRow, EuiModal, EuiModalBody, EuiModalFooter, EuiModalHeaderTitle, EuiSpacer, EuiText } from '@elastic/eui'

import AgencyV2ModalOld from 'features/planner/old-pages/components/AgencyV2ModalOld'

export const ConfirmTotalResetModal = ({ onClose, onResetAll, isLoading }: { onClose: () => void; onResetAll: () => void; isLoading: boolean }) => {
  const [confirmText, setConfirmText] = useState('')

  const confirmDisabled = confirmText.trim().toLowerCase() !== 'confirm'

  return (
    <AgencyV2ModalOld isLoading={isLoading} title='Reset Entire Plan' onClose={onClose} confirmButtonText='Reset All' onConfirmButtonClick={onResetAll} confirmButtonDisabled={confirmDisabled} confirmButtonColor='danger' confirmButtonFilled={false} showCancelButton>
      <EuiText>
        <p>This will reset all the campaigns and the summary paragraphs to the original AI generated content.</p>
      </EuiText>
      <EuiSpacer />
      <EuiFormRow label='Type "confirm" to reset'>
        <EuiFieldText value={confirmText} onChange={e => setConfirmText(e.target.value)} />
      </EuiFormRow>
    </AgencyV2ModalOld>
  )
}
